/**
 * Only the `rpc` method is needed, so apps can pass their own Supabase client
 * whatever supabase-js version they pin.
 */
export interface AnnouncementClient {
  rpc(fn: string, args?: Record<string, unknown>): PromiseLike<{ data: unknown; error: unknown }>;
}

export type AnnouncementAction = 'shown' | 'snooze' | 'dismiss' | 'act';

export interface AnnouncementStatus {
  show: boolean;
  /** Last allowed showing: offer no "Remind me later". */
  final: boolean;
}

export async function getAnnouncementStatus(
  client: AnnouncementClient,
  key: string
): Promise<AnnouncementStatus> {
  try {
    const { data, error } = await client.rpc('get_announcement_status', { p_key: key });
    if (error || !data || typeof data !== 'object') return { show: false, final: false };
    const status = data as { show?: unknown; final?: unknown };
    return { show: status.show === true, final: status.final === true };
  } catch {
    return { show: false, final: false };
  }
}

export async function recordAnnouncementAction(
  client: AnnouncementClient,
  key: string,
  action: AnnouncementAction,
  appSource?: string
): Promise<void> {
  try {
    await client.rpc('record_announcement_action', {
      p_key: key,
      p_action: action,
      p_app_source: appSource ?? null,
    });
  } catch {
    // Best effort: a lost write only means the popup may appear once more.
  }
}
